import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { H3 } from '@appcues/component-library';
import styled from 'styled-components';
import { selectSegmentMemberships } from 'reducers/account/segmentMemberships';
import {
  selectAccountAllTimeStats,
  selectAccountAllTimeStatsSynced,
} from 'reducers/account/allTimeStats';

const StyledH3 = styled(H3)`
  display: inline;
  margin-right: 0.25em;
`;

const Container = styled.div`
  margin-bottom: 1em;
`;

export const WeeklyActiveUserBanner = ({ weeklyUsers = 0, computedAt }) => (
  <Container>
    <StyledH3>{weeklyUsers.toLocaleString()}</StyledH3>
    total users in the last 7 days.{' '}
    {computedAt && `Calculated ${moment(computedAt).calendar().toLowerCase()}`}
  </Container>
);

const mapStateToProps = state => {
  let weeklyUsers = 0;
  let computedAt = null;
  if (Object.keys(selectSegmentMemberships(state)).length > 0) {
    [{ basis: weeklyUsers, computed_at: computedAt }] = Object.values(
      selectSegmentMemberships(state)
    );
  } else if (selectAccountAllTimeStatsSynced(state)) {
    ({ weeklyWebsiteUsers: weeklyUsers, statsLastComputedAt: computedAt } =
      selectAccountAllTimeStats(state));
  }
  return { weeklyUsers, computedAt };
};

export default connect(mapStateToProps)(WeeklyActiveUserBanner);
